import * as angular from "angular";

let InviteConfirmation = {
    selector: "vcInviteConfirmation",
    templateUrl:
        "/angular/components/invite/sections/invite-confirmation.component.html",
    bindings: {
        user: "=",
        emails: "=",
        editStep: "&",
    },
    controller: class InviteConfirmationController {
        // * bindings for typescript compiler *
        public user: any;
        public emails: any;
        public editStep: any;
        // ************************************
    },
};

angular
    .module("invite")
    .component(InviteConfirmation.selector, InviteConfirmation);
